const hslToHex = (h, s, l) => {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r = 0, g = 0, b = 0;
    if (0 <= h && h < 60) [r, g, b] = [c, x, 0];
    else if (60 <= h && h < 120) [r, g, b] = [x, c, 0];
    else if (120 <= h && h < 180) [r, g, b] = [0, c, x];
    else if (180 <= h && h < 240) [r, g, b] = [0, x, c];
    else if (240 <= h && h < 300) [r, g, b] = [x, 0, c];
    else if (300 <= h && h < 360) [r, g, b] = [c, 0, x];

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return `#${((1 << 24) + (r << 16) + (g << 8) + b)
        .toString(16)
        .slice(1)
        .toUpperCase()}`;
}

module.exports = {
    generateBeautifulColorPairs: (count) => {
        const colors = [];
        const saturation = 70;
        const lightness = 55;

        for (let i = 0; i < count; i++) {
            const hue = Math.round((360 * i) / count);
            const bgHex = hslToHex(hue, saturation, lightness);
            const textHex = hslToHex(hue, saturation, lightness > 50 ? 15 : 90);
            colors.push({background: bgHex, text: textHex});
        }

        return colors;
    }
}
